module.exports = __webpack_public_path__ + "img/who-picture.92b8ab53.jpg";